// src/components/ui/AvatarMenu.jsx

import React from "react";
import { Link } from "react-router-dom";
import { UserCircle } from "lucide-react";

/**
 * AvatarMenu.jsx
 * This component renders a generic avatar icon that links to the future /profile page.
 * Once profile image support is added, this component will be updated to display user-uploaded images.
 */

const AvatarMenu = () => {
  return (
    <Link
      to="/profile"
      title="Profile"
      className="hover:opacity-80 transition-opacity cursor-pointer">
      {/*
        - UserCircle: Generic SVG avatar icon from lucide-react
        - w-8 h-8: 2rem square size (standard avatar size)
        - text-white: ensures visibility on dark navbar backgrounds
      */}
      <UserCircle className="w-8 h-8 text-mikado-yellow"/>
    </Link>
  );
};

export default AvatarMenu;
